<template lang="pug">
  div
    b-container
      component(:is="page")
      div.mt-5
        b To apply
        | , or for&nbsp
        b questions
        | , contact&nbsp;
        a(href="mailto:careers@mktbi.com") careers@mktbi.com
        | . Please specify availability date.
    Finisher
    Footer
</template>

<script>
import Footer from "@/components/Shared/Footer";
import VueScrollTo from "vue-scrollto";

export default {
  name: "job",
  components: {Footer},
  data() {
    return {
      page: ''
    }
  },
  beforeMount() {
    this.page = async () => await import(`./jobs/${this.$route.params.job}.vue`)
    VueScrollTo.scrollTo({y: 0})
  }
}
</script>